/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOrphanedAwsAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOrphanedAwsAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOrphanedAwsAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOrphanedAwsAdvisorResource>): RecommendationForFinopsOrphanedAwsAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsOrphanedAwsAdvisorResource(), model);
        RecommendationForFinopsOrphanedAwsAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOrphanedAwsAdvisorResource>): RecommendationForFinopsOrphanedAwsAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsOrphanedAwsAdvisorResource.newInstance(<RecommendationForFinopsOrphanedAwsAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOrphanedAwsAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsOrphanedAwsAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOrphanedAwsAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOrphanedAwsAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
